/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What the DMS reconciler last observed for the company's schema, or the onboarding stage it is driving
 */
export enum EtlTenantStatus {
    REPLICATING = 'replicating',
    LOADING = 'loading',
    STAGING = 'staging',
    SILVER = 'silver',
    GOLD = 'gold',
    FAILED = 'failed',
    PENDING = 'pending',
    REMOVING = 'removing',
    REMOVED = 'removed',
}
